<template>
  <v-hover v-slot:default="{ hover }">
    <v-card :elevation="hover ? 8 : 2" color="blue5" @click="doNavigation">
      <v-card-title style="white-space:pre;" class="subtitle-1">
        <span v-if="profile.title">{{ profile.title }} </span>
        <span v-if="profile.firstName">{{ profile.firstName }} </span>
        <span v-if="profile.lastName">{{ profile.lastName }}</span>
        <span v-if="profile.suffix"> {{ profile.suffix }}</span>
        <span v-if="profile.nickName"> ({{ profile.nickName }})</span>
        <v-spacer />
        <v-icon v-if="hasCellPhone" class="px-2">mdi-message-outline</v-icon>
        <v-icon v-if="hasPhone" class="px-2">mdi-phone</v-icon>
        <v-icon v-if="hasEmail" class="px-2">mdi-email</v-icon>
      </v-card-title>
      <v-card-subtitle>
        {{ profile.isMainContact ? 'Main Contact' : '' }}
        <span v-if="profile.relationship && profile.isMainContact" style="whitespace:pre"> - </span>
        {{ profile.relationship }}
      </v-card-subtitle>
    </v-card>
  </v-hover>
</template>

<style>
</style>

<script>
import analyticsService from '@/services/shared/analyticsService.js';
import { mapActions } from 'vuex';

export default {
  name: 'PersonalProfileSummary',
  props: {
    profile: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      hover: false,
      phoneTypes: [1, 2, 3, 4],
      emailTypes: [8, 9, 10]
    };
  },
  computed: {
    sortedContacts: function () {
      if ((this.profile || null) === null) return null;
      if ((this.profile.contacts || null) === null || this.profile.contacts.length === 0) return null;

      return this.profile.contacts.concat().sort((x, y) => {
        if (x.displayOrder < y.displayOrder) return -1;
        if (x.displayOrder > y.displayOrder) return 1;
        return 0;
      });
    },
    primaryPhone: function () {
      return this.getPrimaryContactByType(this.phoneTypes);
    },
    primaryPhoneProtocol: function () {
      if ((this.primaryPhone || null) === null) return null;
      return `tel:${this.primaryPhone.data}`;
    },
    primaryEmail: function () {
      return this.getPrimaryContactByType(this.emailTypes);
    },
    primaryEmailProtocol: function () {
      if ((this.primaryEmail || null) === null) return null;
      return `mailto:${this.primaryEmail.data}`;
    },
    hasCellPhone: function () {
      return (this.profile.contactTypes & 1) > 0;
    },
    hasPhone: function () {
      return (this.profile.contactTypes & 2) > 0;
    },
    hasEmail: function () {
      return (this.profile.contactTypes & 4) > 0;
    }
  },
  methods: {
    ...mapActions(['setSelectedProfile']),
    getPrimaryContactByType: function (types) {
      if ((types || null) === null || types.length === 0) return null;
      if (this.sortedContacts === null) return null;

      var index = this.sortedContacts.findIndex(x => types.includes(x.contactType));
      if (index >= 0) {
        return this.profile.contacts[index];
      }

      return null;
    },
    doNavigation () {
      if ((this.profile || null) === null) return;
      analyticsService.sendEvent(this.$gtag, 'Button Click', 'Client', 'Person Select');
      this.setSelectedProfile(this.profile.id);
    }
  }
};
</script>
